module.exports = __webpack_public_path__ + "img/doc-chat.d8c820ae.png";